document.addEventListener("DOMContentLoaded", function () {
	const galleries = {};

	// Prepara i dati per ogni galleria
	document.querySelectorAll("[data-gallery-group]").forEach((galleryContainer) => {
		const galleryId = galleryContainer.getAttribute("data-gallery-group");
		const galleryItems = [];

		// Trova tutte le immagini della galleria
		galleryContainer.querySelectorAll(".gallery-image").forEach((image) => {
			const index = image.getAttribute("data-gallery-index");
			const fullImage = {
				src: image.getAttribute("data-full-src") || image.querySelector("img").getAttribute("src"),
				w: image.dataset.width || 600,
				h: image.dataset.height || 400,
				title: image.dataset.title || "",
			};
			galleryItems[index] = fullImage;
		});

		galleries[galleryId] = galleryItems;

		// Aggiungi eventi click
		galleryContainer.querySelectorAll(".gallery-image").forEach((image) => {
			image.addEventListener("click", function (e) {
				e.preventDefault();

				const index = parseInt(this.getAttribute("data-gallery-index"), 10);
				const pswpElement = document.querySelector(".pswp");

				const gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, galleries[galleryId], {
					index: index,
					bgOpacity: 0.85,
					showHideOpacity: true,
				});

				gallery.init();
			});
		});
	});
});
